(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ncBound) return;
    root.dataset.ncBound = '1';
    var btn = root.querySelector('[data-nc-more]');
    if (!btn) return;
    var step = parseInt(root.getAttribute('data-initial'), 10) || 12;
    btn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('[data-nc-review][hidden]');
      for (var i = 0; i < hidden.length && i < step; i++) hidden[i].hidden = false;
      if (hidden.length <= step) btn.parentNode.hidden = true;
    });
  }
  function boot() { document.querySelectorAll('[data-nc-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ncBound) return;
    root.dataset.ncBound = '1';
    var track = root.querySelector('[data-nc-track]');
    if (!track) return;
    var speed = parseFloat(root.getAttribute('data-autoscroll')) || 0;
    var paused = false, playing = false, last = null, half = 0;

    // Videos
    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-nc-video]');
      if (!card) return;
      var media = card.querySelector('.nc-vt__media');
      var video = card.querySelector('video');
      if (!video) {
        var src = card.getAttribute('data-src');
        if (!src) return;
        video = document.createElement('video');
        video.src = src;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.loop = true;
        media.appendChild(video);
      }
      root.querySelectorAll('[data-nc-video].is-playing').forEach(function (other) {
        if (other === card) return;
        var v = other.querySelector('video');
        if (v) v.pause();
        other.classList.add('is-paused');
      });
      if (card.classList.contains('is-playing') && !card.classList.contains('is-paused')) {
        video.pause();
        card.classList.add('is-paused');
      } else {
        card.classList.add('is-playing');
        card.classList.remove('is-paused');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      playing = !!root.querySelector('[data-nc-video].is-playing:not(.is-paused)');
    });

    // Auto-scroll (marquee): duplicate the cards once so the loop is seamless
    if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var originals = Array.prototype.slice.call(track.children);
      originals.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
      var measure = function () {
        var first = originals[0], firstClone = track.children[originals.length];
        half = firstClone && first ? firstClone.offsetLeft - first.offsetLeft : 0;
      };
      measure();
      window.addEventListener('resize', measure);
      ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) {
        track.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['pointerup', 'touchend', 'mouseleave'].forEach(function (ev) {
        track.addEventListener(ev, function () { setTimeout(function () { paused = false; last = null; }, 1200); }, { passive: true });
      });
      var pos = 0;
      var tick = function (ts) {
        if (last !== null && !paused && !playing && half > 0) {
          pos = track.scrollLeft + (speed * (ts - last)) / 1000;
          if (pos >= half) pos -= half;
          track.scrollLeft = pos;
        }
        last = ts;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    // Arrows + progress
    var prev = root.querySelector('[data-nc-prev]');
    var next = root.querySelector('[data-nc-next]');
    var bar = root.querySelector('[data-nc-progress]');
    function stepSize() {
      var card = track.querySelector('.nc-vt__card');
      return card ? card.offsetWidth + 16 : 300;
    }
    function nudge(dir) {
      paused = true;
      track.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });
      setTimeout(function () { paused = false; last = null; }, 2500);
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    function progress() {
      if (!bar) return;
      var total = half > 0 ? half : track.scrollWidth - track.clientWidth;
      var ratio = total > 0 ? Math.min(1, (track.scrollLeft % (total || 1)) / total) : 0;
      var visible = Math.max(18, Math.min(100, (track.clientWidth / Math.max(1, half > 0 ? half : track.scrollWidth)) * 100));
      bar.style.width = visible + '%';
      bar.style.marginLeft = (100 - visible) * ratio + '%';
    }
    track.addEventListener('scroll', progress, { passive: true });
    progress();
  }
  function boot() { document.querySelectorAll('[data-nc-testimonials]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
